const actionType = {
    SHOW_IS_LOADING: "SHOW_IS_LOADING",
    HIDE_IS_LOADING: "HIDE_IS_LOADING",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAILURE: "LOGIN_FAILURE",
    CHANGEPASSWORD_SUCCESS: "CHANGEPASSWORD_SUCCESS",
    CHANGEPASSWORD_FAILURE: "CHANGEPASSWORD_FAILURE",
    FORGOTPASSWORD_SUCCESS: "FORGOTPASSWORD_SUCCESS",
    FORGOTPASSWORD_FAILURE: "FORGOTPASSWORD_FAILURE",
    PROFILE_SUCCESS  : "PROFILE_SUCCESS",
    PROFILE_FAILURE :  "PROFILE_FAILURE",
    EDITPROFILE_SUCCESS  : "EDITPROFILE_SUCCESS",
    EDITPROFILE_FAILURE :  "EDITPROFILE_FAILURE",
    NEWPASS_SUCCESS : "NEWPASS_SUCCESS",
    NEWPASS_FAILURE : "NEWPASS_FAILURE",
    RANDOMPASS_SUCCESS: "RANDOMPASS_SUCCESS",
    RANDOMPASS_FAILURE : "RANDOMPASS_FAILURE",
    GET_NPI_DATA_SUCCESS :"GET_NPI_DATA_SUCCESS",
    GET_NPI_DATA_FAILURE : "GET_NPI_DATA_FAILURE",
    EMAIL_VALID_SUCCESS  :"EMAIL_VALID_SUCCESS",
    EMAIL_VALID_FAILURE : "EMAIL_VALID_FAILURE",
    MOBILE_VALID_SUCCESS  :"MOBILE_VALID_SUCCESS",
    MOBILE_VALID_FAILURE  :"MOBILE_VALID_FAILURE",
    LOGOUT_USER : "LOGOUT_USER",
    CONTACT_SUCCESS: "CONTACT_SUCCESS",
    CONTACT_FAILURE: "CONTACT_FAILURE",
    VIEWREQUESTINFO_SUCCESS : "VIEWREQUESTINFO_SUCCESS",
    VIEWREQUESTINFO_FAILURE : "VIEWREQUESTINFO_FAILURE ",
    VIEW_STATUS_CHANGE : "VIEW_STATUS_CHANGE",
    VERIFY_REGISTER_SUCCESS : "VERIFY_REGISTER_SUCCESS",
    VERIFY_REGISTER_FAILURE  :"VERIFY_REGISTER_FAILURE",
    VERIFY_REGISTER_WARNING : "VERIFY_REGISTER_WARNING",
    REFRESH_ACCESS_TOKEN_SUCCESS : "REFRESH_ACCESS_TOKEN_SUCCESS",
    SESSION_EXPIRED : "SESSION_EXPIRED",
    SESSION_EXPIRE_FALSE : "SESSION_EXPIRE_FALSE",
    RESEND_VERIFY_EMAIL_SUCCESS : "RESEND_VERIFY_EMAIL_SUCCESS",
    RESEND_VERIFY_EMAIL_FAILURE : "RESEND_VERIFY_EMAIL_FAILURE"

  };
  export default actionType;
  